import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';
import Chip from '@mui/material/Chip';

export default function PortfolioTable(props) {
    return (
        <Stack spacing={1}>
            <Typography variant="h6" gutterBottom>
                <Stack spacing={3} direction="row" alignItems="end">
                    <div>Total items: {props.pagination?.total}</div>
                    {props.headerContent}
                </Stack>
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: 100 }} align="center">Name</TableCell>
                            {props.withAiRate ?
                            <TableCell sx={{ width: 100 }} align="center">AI Rate</TableCell>
                            : null }
                            <TableCell sx={{ width: 600 }} align="center">Description</TableCell>
                            <TableCell sx={{ width: 80 }} align="center">Actions</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items?.map((row) => (
                            <TableRow
                                hover
                                key={row.id}
                                sx={{ cursor: 'pointer' }}
                                onClick={() => {props.btnEditHandle(row)} }
                            >
                                <TableCell align="left">{row.name}</TableCell>
                                {props.withAiRate ?
                                <TableCell align="left">{Math.round(row.similarity * 1000000) / 1000000}</TableCell>
                                : null }
                                <TableCell align="left">{row.description}</TableCell>
                                <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                    <Tooltip arrow title="Edit Portfolio Item">
                                        <IconButton 
                                            component="label" 
                                            onClick={() => { props.btnEditHandle(row) }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip arrow title="Delete Portfolio Item">
                                        <IconButton 
                                            component="label" 
                                            onClick={(e) => {e.stopPropagation(); props.btnDeleteHandle(row) }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell />
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{p:1}}>
                    <Pagination page={props.pagination?.page} count={props.pagination?.pages} color="primary" onChange={(event, value) => { props.handlePaginate(value - 1) }} />

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small" variant="standard">
                        <InputLabel id="demo-select-small-label">Per page</InputLabel>
                        <Select
                            variant="standard"
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={props.pagination?.perpage}
                            defaultValue={props.pagination?.perpage}
                            label="Per page"
                            onChange={(event) => { props.handleChangePerpage(event.target.value) }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </TableContainer>
        </Stack>
    );
}
